export const getIndicators = (collaborationAgreementSubmissions: any[], monitoringSubmissions: any[]) => {
    const values = {
        volunteerRecruitment: 0,
        provisionServices : monitoringSubmissions.filter(submission => submission.domanda28 === '1').length,
        volunteerWork: 0,
    };

    collaborationAgreementSubmissions.forEach(submission => {
        const agreement = submission.domanda4 || '';

        if (agreement === '1') {
            values.volunteerRecruitment++;
        } else if (agreement === '2') {
            values.volunteerWork++;
        }
    })

    return Object.values(values);
}

export const getExpectedIndicators = (collaborationAgreementSubmissions: any[]) => {
    const values = {
        volunteerRecruitment: 5,
        provisionServices : 0,
        volunteerWork: 10,
    };

    collaborationAgreementSubmissions.forEach(submission => {
        values.provisionServices += Number(submission.domanda5);
    })

    return Object.values(values);
}